export default "__VITE_ASSET__PRzzkawg__"